import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("iswear_lang") || "no");
  // Source/collection language: always defaults to Norwegian on a fresh visit (not persisted).
  const [sourceLang, setSourceLang] = useState("no");
  const [ageAccepted, setAgeAccepted] = useState(
    () => sessionStorage.getItem("iswear_age_ok") === "1",
  );

  useEffect(() => {
    localStorage.setItem("iswear_lang", lang);
  }, [lang]);

  const acceptAge = useCallback(() => {
    sessionStorage.setItem("iswear_age_ok", "1");
    setAgeAccepted(true);
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, sourceLang, setSourceLang, ageAccepted, acceptAge }),
    [lang, sourceLang, ageAccepted, acceptAge],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
}
